/* global google */
import React, { Component } from 'react';

class MapView extends Component {
  state = {
    map: null,
    marker: null
  }

  componentDidMount() {
    let map = new google.maps.Map(document.getElementById('map-view'), {
      center: { lng: this.props.data.lng, lat: this.props.data.lat },
      zoom: 14,
      disableDefaultUI: true,
    })
    let marker = new google.maps.Marker({
      position: { lng: this.props.data.lng, lat: this.props.data.lat },
      map: map,
    });
    map.addListener("click", (e) => {
      marker.setMap(null)
      marker = new google.maps.Marker({
        position: e.latLng,
        map: map,
      });
      this.props.onChange('lat', e.latLng.lat())
      this.props.onChange('lng', e.latLng.lng())
      this.setState({ marker })
    })
    this.setState({ map, marker })
  }

  render() {
    return (
      <div id='map-view' style={{ margin: '8px', height: '250px' }}></div>
    )
  }
}
export default MapView;
